/**
 * True when URL targets Shared Documents in this web app (SPA deep link).
 * Accepts absolute URLs and paths resolveable against `window.location`.
 */
export default function isSharedDocumentsWebUrl(href) {
  if (!href || typeof href !== 'string') return false;
  try {
    const base = typeof window !== 'undefined' ? window.location.href : undefined;
    const u = new URL(href, base);
    return /\/home\/documents\/shared(?:\/|$|\?)/.test(u.pathname);
  } catch {
    return false;
  }
}
